export const paymentMethodsTip = `<span>
①一次性：生成一条应收账款，按指定日期付款<br>
②年付：按年生成应收账款<br>
③半年一付：每六个月生成一期应收账款<br>
④三月一付：每三个月生成一期应收账款<br>
⑤周付：应收账款每7天为一期，按指定星期付款，如缴款日为周一，则每周一为缴款日<br>
⑥日付：按日生成应收账款<br>
⑦月付（自然月）：第一期不足一个月先生成一期应收账款，后面按自然月生成应收账款，比如合同开始时间2019.8.25，那么<br>
  &nbsp &nbsp &nbsp第一期：2019.8.25-2019.8.31<br>
  &nbsp &nbsp &nbsp第二期：2019.9.1-2019-9.30<br>
  &nbsp &nbsp &nbsp ...<br>
⑧月付（满月）：应收账款按照整月生成，比如合同开始时间2019.8.25，那么<br>
  &nbsp &nbsp &nbsp第一期：2019.8.25 - 2019.9.24<br>
  &nbsp &nbsp &nbsp第二期：2019.9.25 - 2019.10.24<br>
  &nbsp &nbsp &nbsp ...<br>
⑨ 30天一付：每30天生成一期应收账款<br>
⑩ 司机合作模式：针对公司自行招聘的司机，不需收取租金
`
export const moneyTip = '当付款方式非“一次性”时,所填金额为每期金额'
export const payPost = '开启时，应缴日期默认为单个账期的结束日+1天'
export const presentDays = '填写后，系统将根据赠送天数从收款结束日往前推，额外生成一期金额为0的应收账单'
// 不足月租金计算规则
export const rentCalculationRuleTip = `
  <span>
  1. 不足月租金：不满一个月的款项周期生成的租金<br>
  2. 日租金规则：<br>
  2.1 当月自然天数计算：日租金=每期租金/当月自然天数<br>
  2.2 每月30天计算：日租金=每期租金/30天<br>
  3.首期租金=日租金*首期租赁天数 <br>
  4.尾期租金=每期租金-首期租金 <br>
  </span>
`
// 车辆管理-批量新建
export const importInstructionsList = [
  '1.请使用标准模版，确认未进行过任何更改，若无意中修改了模版的原有内容，建议重新下载模版；',
  '2.确保Excel中标题行的名称和表单中与之对应的字段标题一致，且表单中字段名称不能相同；',
  '3.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
  '4.确保excel中数据格式正确。比如VIN码为数字加字母格式，请不要输入汉字；',
  '5.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
  '6.Excel多余的列无法导入，请删除Excel中不需要导入的列；',
  '7.需明确系统是否已添加表格中需要添加的车源方和产权方；',
]

export const dailyRuleEnum = {
  NATURE_MONTH: 0,
  THIRTY_DAY: 1,
}

export const dailyRuleState = {
  0: '期始月份自然天数计算',
  1: '每月30天计算',
}
